import { render, staticRenderFns } from "./base-icon.vue?vue&type=template&id=2e9acb22&scoped=true"
import script from "./base-icon.vue?vue&type=script&setup=true&lang=js"
export * from "./base-icon.vue?vue&type=script&setup=true&lang=js"
import style0 from "./base-icon.vue?vue&type=style&index=0&id=2e9acb22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9acb22",
  null
  
)

export default component.exports